/* Weihnachten theme - vanilla JS, no dependencies */
(function () {
  'use strict';

  var root = document.documentElement;
  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var lastFocus = null;
  var toastTimer = null;

  function toast(message, isError) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function setCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }

  /* drawers */
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    root.classList.add('drawer-open');
    var panel = $('.drawer__panel', drawer);
    if (panel) panel.focus({ preventScroll: true });
    var toggle = $('[data-menu-toggle]');
    if (toggle && drawer.id === 'MobileMenu') toggle.setAttribute('aria-expanded', 'true');
  }

  function closeDrawers() {
    $$('.drawer[aria-hidden="false"]').forEach(function (d) { d.setAttribute('aria-hidden', 'true'); });
    root.classList.remove('drawer-open');
    var toggle = $('[data-menu-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function openCart() {
    var drawer = $('[data-cart-drawer]');
    if (drawer) openDrawer(drawer);
    else window.location.href = T.routes.cart;
  }

  /* cart */
  function refreshCart() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var prevN = window.WN._n; if (prevN == null) { var cc = $('[data-cart-count]'); prevN = cc ? parseInt(cc.textContent, 10) || 0 : 0; }
        var addedTitle = (cart.item_count > prevN && cart.items && cart.items[0]) ? cart.items[0].product_title : '';
        window.WN._n = cart.item_count;
        setCount(cart.item_count);
        var jobs = [];
        var drawer = $('[data-cart-drawer]');
        if (drawer) {
          jobs.push(
            fetch(T.routes.root + '?sections=cart-drawer')
              .then(function (r) { return r.json(); })
              .then(function (sections) {
                var doc = parseHTML(sections['cart-drawer'] || '');
                var fresh = $('[data-cart-drawer] .drawer__panel', doc);
                var panel = $('.drawer__panel', drawer);
                if (fresh && panel) panel.innerHTML = fresh.innerHTML;
                if (addedTitle && drawer.getAttribute('data-added') === 'true' && panel) {
                  var body = $('.drawer__body', panel);
                  if (body) {
                    var msg = document.createElement('div'); msg.className = 'cd-added'; msg.setAttribute('role', 'status');
                    var lab = document.createElement('span'); lab.textContent = (T.strings && T.strings.addedLabel) || 'Hinzugefügt: ';
                    var st = document.createElement('strong'); st.textContent = addedTitle;
                    msg.appendChild(lab); msg.appendChild(st); body.insertBefore(msg, body.firstChild);
                    setTimeout(function () { if (msg.parentNode) msg.parentNode.removeChild(msg); }, 5000);
                  }
                }
              })
          );
        }
        var page = $('[data-cart-page]');
        if (page) {
          jobs.push(
            fetch(T.routes.cart + '?section_id=' + page.getAttribute('data-section-id'))
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var fresh = $('[data-cart-page]', parseHTML(html));
                if (fresh) page.innerHTML = fresh.innerHTML;
              })
          );
        }
        return Promise.all(jobs).then(function () { initUpsell(); return cart; });
      });
  }

  function addToCart(formData, button) {
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || T.strings.error);
        return refreshCart();
      })
      .then(function () {
        if (T.cartType === 'drawer' && T.autoOpen !== false && $('[data-cart-drawer]')) openCart();
        else toast(T.strings.added);
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.disabled = false; }
      });
  }

  function changeCart(key, quantity) {
    var scope = $$('.cart-items');
    scope.forEach(function (el) { el.classList.add('is-loading'); });
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status && json.description) toast(json.description, true);
        return refreshCart();
      })
      .catch(function () { toast(T.strings.error, true); })
      .finally(function () { scope.forEach(function (el) { el.classList.remove('is-loading'); }); });
  }

  /* variants */
  function selectedOptions(picker) {
    return $$('.option', picker).map(function (group) {
      var radio = $('[data-option-radio]:checked', group);
      if (radio) return radio.value;
      var select = $('[data-option-select]', group);
      return select ? select.value : null;
    });
  }

  function matches(variant, selected) {
    return selected.every(function (val, i) { return variant['option' + (i + 1)] === val; });
  }

  function markOptions(picker, variants, selected) {
    $$('.option', picker).forEach(function (group, gi) {
      $$('[data-option-radio]', group).forEach(function (radio) {
        var test = selected.slice();
        test[gi] = radio.value;
        var available = variants.some(function (v) { return v.available && matches(v, test); });
        var label = radio.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !available);
      });
      var lbl = $('[data-option-label]', group);
      if (lbl) lbl.textContent = selected[gi];
    });
  }

  function scrollToMedia(section, id) {
    var main = $('[data-gallery-main]', section);
    var slide = main && $('[data-media-id="' + id + '"]', main);
    if (!slide) return;
    var lay = main.closest('[data-gallery]');
    lay = lay && lay.getAttribute('data-layout');
    if (lay === 'grid' || lay === 'stacked') slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    else main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  function onVariantChange(picker) {
    var section = picker.closest('[data-product-section]');
    var json = $('[data-product-json]', picker);
    if (!section || !json) return;
    var product = JSON.parse(json.textContent);
    var selected = selectedOptions(picker);
    markOptions(picker, product.variants, selected);
    var variant = product.variants.filter(function (v) { return matches(v, selected); })[0];
    var button = $('[data-add-button]', section);

    if (!variant) {
      if (button) { button.disabled = true; button.textContent = T.strings.soldOut; }
      return;
    }
    var input = $('[data-variant-input]', section);
    if (input) input.value = variant.id;
    if (window.history && history.replaceState) {
      history.replaceState({}, '', window.location.pathname + '?variant=' + variant.id);
    }
    if (variant.featured_media) scrollToMedia(section, variant.featured_media.id);
    document.dispatchEvent(new CustomEvent('wn:variant', { detail: { section: section, variant: variant } }));

    var url = section.getAttribute('data-product-url') + '?variant=' + variant.id + '&section_id=' + section.getAttribute('data-section-id');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var seen = {};
        var fresh = $$('[data-update]', doc);
        $$('[data-update]', section).forEach(function (el) {
          var k = el.getAttribute('data-update');
          var n = seen[k] = (seen[k] || 0) + 1;
          var match = fresh.filter(function (f) { return f.getAttribute('data-update') === k; })[n - 1];
          if (match) el.innerHTML = match.innerHTML;
        });
        document.dispatchEvent(new CustomEvent('wn:updated', { detail: { section: section, variant: variant } }));
      });
  }

  /* gallery + sticky add to cart */
  function initGallery(gallery) {
    if (gallery.__init) return;
    gallery.__init = true;
    var main = $('[data-gallery-main]', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    if (!main || !thumbs.length) return;
    var ticking = false;
    main.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var index = Math.round(main.scrollLeft / main.clientWidth);
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        ticking = false;
      });
    }, { passive: true });
  }

  function initStickyAtc() {
    $$('[data-product-section]').forEach(function (section) {
      var bar = $('[data-sticky-atc]', section);
      var target = $('.product__buy', section);
      if (!bar || !target || !('IntersectionObserver' in window) || bar.__init) return;
      bar.__init = true;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.hidden = !(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(target);
    });
  }

  /* countdown */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      if (el.__cd) return;
      el.__cd = true;
      var raw = (el.getAttribute('data-target') || '').trim();
      var target = raw ? new Date(raw.replace(' ', 'T')) : null;
      var daily = !raw || isNaN(target);
      var compact = el.hasAttribute('data-compact');
      function nextMidnight() { var d = new Date(); d.setHours(24, 0, 0, 0); return d; }
      if (daily) { el.style.display = 'none'; return; } /* no valid end date: never show an endlessly restarting timer */

      function set(unit, value) {
        var node = $('[data-unit="' + unit + '"]', el);
        if (node) node.textContent = pad(value);
      }
      var timer = setInterval(tick, 1000);
      function tick() {
        var diff = target - new Date();
        if (diff <= 0) {
          if (daily) { target = nextMidnight(); return; }
          clearInterval(timer);
          if (el.getAttribute('data-end') === 'hide') { var sw = el.closest('.shopify-section'); if (sw && !(window.Shopify && window.Shopify.designMode)) { sw.style.display = 'none'; return; } }
          el.textContent = T.strings.countdownEnded || '';
          return;
        }
        var total = Math.floor(diff / 1000);
        var days = Math.floor(total / 86400);
        var hours = Math.floor((total % 86400) / 3600);
        var minutes = Math.floor((total % 3600) / 60);
        var seconds = total % 60;
        var dn = $('[data-unit="days"]', el), fold = compact || !dn || (dn.parentNode && dn.parentNode.hidden);
        if (fold) hours += days * 24; else set('days', days);
        set('hours', hours);
        set('minutes', minutes);
        set('seconds', seconds);
      }
      tick();
    });
  }

  /* misc */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar || bar.__init) return;
    bar.__init = true;
    var key = bar.getAttribute('data-dismiss-key');
    try { if (key && sessionStorage.getItem(key)) bar.classList.add('is-dismissed'); } catch (e) {}
    var close = $('[data-announcement-close]', bar);
    if (close) close.addEventListener('click', function () { bar.classList.add('is-dismissed'); try { sessionStorage.setItem(key, '1'); } catch (e) {} });
    var mode = bar.getAttribute('data-mode');
    if (mode === 'ticker' || mode === 'static') return;
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      var prev = items[i];
      prev.classList.remove('is-active'); prev.classList.add('is-leaving');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 520);
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, parseInt(bar.getAttribute('data-speed'), 10) || 5000);
  }

  function initRecommendations() {
    $$('[data-recs]').forEach(function (el) {
      if (el.__init) return;
      el.__init = true;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = $('[data-recs]', parseHTML(html));
          if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  function initRecoverToggle() {
    var login = $('#CustomerLogin');
    var recover = $('#CustomerRecover');
    if (!login || !recover) return;
    function show(isRecover) { login.hidden = isRecover; recover.hidden = !isRecover; }
    show(window.location.hash === '#recover');
    if ($('#CustomerRecover .form-message--success')) show(true);
  }

  window.WN = { toast: toast, refreshCart: refreshCart, openCart: openCart, openModal: function (m) { openModal(m); } };

  function init() {
    $$('[data-gallery]').forEach(initGallery);
    $$('[data-variant-picker]').forEach(function (picker) {
      if (picker.__init) return;
      picker.__init = true;
      var json = $('[data-product-json]', picker);
      if (json) markOptions(picker, JSON.parse(json.textContent).variants, selectedOptions(picker));
    });
    initStickyAtc();
    initCountdowns();
    initAnnouncement();
    initRecommendations();
    initRecoverToggle();
  }

  /* events */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if (t.closest('[data-menu-toggle]')) { openDrawer($('#MobileMenu')); return; }
    if (t.closest('[data-drawer-close]')) { closeDrawers(); return; }

    if ((el = t.closest('[data-search-toggle]'))) {
      var bar = $('[data-search-bar]');
      if (!bar) return;
      var open = bar.hidden;
      bar.hidden = !open;
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var input = $('input[type="search"]', bar); if (input) input.focus(); }
      return;
    }

    if (t.closest('[data-cart-link]')) {
      if (T.cartType === 'drawer' && $('[data-cart-drawer]')) { e.preventDefault(); openCart(); }
      return;
    }

    if ((el = t.closest('[data-quick-add]'))) {
      var fd = new FormData();
      fd.append('id', el.getAttribute('data-variant-id'));
      fd.append('quantity', 1);
      addToCart(fd, el).catch(function (err) { toast(err.message, true); });
      return;
    }

    if ((el = t.closest('[data-qty-step]'))) {
      var qtyInput = $('.qty__input', el.parentNode);
      var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(el.getAttribute('data-qty-step'), 10);
      qtyInput.value = Math.max(parseInt(qtyInput.min, 10) || 1, next);
      return;
    }

    if ((el = t.closest('[data-qty-change]'))) {
      var key = el.getAttribute('data-key');
      var field = $('[data-qty-input][data-key="' + key + '"]', el.closest('.cart-item'));
      var qty = Math.max(0, (parseInt(field.value, 10) || 0) + parseInt(el.getAttribute('data-qty-change'), 10));
      changeCart(key, qty);
      return;
    }

    if ((el = t.closest('[data-remove]'))) { changeCart(el.getAttribute('data-key'), 0); return; }

    if ((el = t.closest('[data-thumb]'))) {
      var section = el.closest('[data-product-section]');
      if (section) scrollToMedia(section, el.getAttribute('data-media-id'));
      return;
    }

    if ((el = t.closest('[data-sticky-submit]'))) {
      var form = document.getElementById(el.getAttribute('data-form'));
      if (form && form.requestSubmit) form.requestSubmit();
      return;
    }

    if ((el = t.closest('[data-share]'))) {
      var url = el.getAttribute('data-url');
      if (navigator.share) {
        navigator.share({ title: el.getAttribute('data-title'), url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { toast(el.getAttribute('data-copied')); });
      }
      return;
    }

    if ((el = t.closest('[data-filter-toggle]'))) {
      var filters = $('[data-filters]');
      if (filters) {
        var isOpen = filters.classList.toggle('is-open');
        el.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
      return;
    }

    if ((el = t.closest('[data-recover-toggle]'))) {
      e.preventDefault();
      var isRecover = el.getAttribute('href') === '#recover';
      $('#CustomerLogin').hidden = isRecover;
      $('#CustomerRecover').hidden = !isRecover;
      return;
    }

    if ((el = t.closest('[data-address-toggle]'))) {
      var box = document.getElementById(el.getAttribute('data-address-toggle'));
      if (box) box.hidden = !box.hidden;
      return;
    }

    if ((el = t.closest('[data-address-delete]'))) {
      if (window.confirm(el.getAttribute('data-confirm')) && window.Shopify && Shopify.CustomerAddress) {
        Shopify.CustomerAddress.destroy(el.getAttribute('data-address-delete'));
      }
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-option-radio], [data-option-select]')) {
      var picker = t.closest('[data-variant-picker]');
      if (picker) onVariantChange(picker);
      return;
    }
    if (t.matches('[data-qty-input]')) {
      changeCart(t.getAttribute('data-key'), Math.max(0, parseInt(t.value, 10) || 0));
      return;
    }
    if (t.matches('[data-auto-submit]')) {
      var form = t.form || document.getElementById('FilterForm');
      if (form) form.submit();
      return;
    }
    if (t.matches('[data-cart-note]')) {
      fetch(T.routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: t.value })
      });
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    e.preventDefault();
    var button = $('[data-add-button]', form);
    var errorBox = $('[data-form-error]', form);
    if (errorBox) errorBox.hidden = true;
    var wrap = form.id ? document.querySelector('[data-gift-wrap][form="' + form.id + '"]:checked') : null;
    var pre = Promise.resolve();
    if (wrap && wrap.getAttribute('data-wrap-variant')) {
      pre = fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: parseInt(wrap.getAttribute('data-wrap-variant'), 10), quantity: 1 }) }).catch(function () {});
    }
    pre.then(function () { return addToCart(new FormData(form), button); }).then(function () { closeModals(); document.dispatchEvent(new CustomEvent('wn:added', { detail: { button: button, form: form } })); }).catch(function (err) {
      if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
      else toast(err.message, true);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawers();
      var bar = $('[data-search-bar]');
      if (bar && !bar.hidden) bar.hidden = true;
    }
  });

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* ===== Effects: reveal, parallax, snow, slideshow, video, popup ===== */
  function initEffects() {
    var anims = $$('[data-anim]:not(.is-visible)');
    if ('IntersectionObserver' in window && anims.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { threshold: 0.12 });
      anims.forEach(function (el) { io.observe(el); });
    } else { anims.forEach(function (el) { el.classList.add('is-visible'); }); }

    $$('[data-slideshow]').forEach(function (box) {
      if (box._ss) return; box._ss = true;
      var track = $('[data-slides]', box), n = track.children.length, i = 0, timer;
      var dots = $$('[data-slide-dot]', box);
      var fade = box.dataset.trans === 'fade', slides = Array.prototype.slice.call(track.children);
      function go(k) {
        i = (k + n) % n; track.style.transform = fade ? 'none' : 'translateX(' + (-100 * i) + '%)';
        slides.forEach(function (s, j) { s.classList.toggle('is-current', j === i); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }
      function play() {
        clearInterval(timer);
        if (box.dataset.autoplay === 'true' && n > 1) timer = setInterval(function () { go(i + 1); }, parseInt(box.dataset.speed, 10) || 6000);
      }
      var pv = $('[data-slide-prev]', box), nx = $('[data-slide-next]', box);
      if (pv) pv.addEventListener('click', function () { go(i - 1); play(); });
      if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); play(); }); });
      var sx0 = null;
      box.addEventListener('touchstart', function (e) { sx0 = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (sx0 === null) return; var dx = e.changedTouches[0].clientX - sx0;
        if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); } sx0 = null;
      });
      if (box.dataset.hover !== 'false') box.addEventListener('mouseenter', function () { clearInterval(timer); });
      box.addEventListener('mouseleave', play);
      play();
    });

    $$('[data-video-toggle]').forEach(function (btn) {
      if (btn._vt) return; btn._vt = true;
      btn.addEventListener('click', function () {
        var v = btn.parentNode.querySelector('video'); if (!v) return;
        if (v.paused) { v.play(); btn.textContent = '❚❚'; } else { v.pause(); btn.textContent = '▶'; }
      });
    });

    var canvas = $('[data-snow]');
    if (canvas && !canvas._snow && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      canvas._snow = true;
      var ctx = canvas.getContext('2d'), W, H, flakes = [], count = parseInt(canvas.dataset.count, 10) || 70;
      var resize = function () { W = canvas.width = window.innerWidth; H = canvas.height = window.innerHeight; };
      resize(); window.addEventListener('resize', resize);
      for (var k = 0; k < count; k++) flakes.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 3 + 1, d: Math.random() * 1 + .4, a: Math.random() * Math.PI * 2 });
      (function frame() {
        ctx.clearRect(0, 0, W, H); ctx.fillStyle = 'rgba(255,255,255,.9)'; ctx.shadowColor = 'rgba(0,0,0,.25)'; ctx.shadowBlur = 3;
        flakes.forEach(function (f) {
          f.y += f.d + f.r * .25; f.a += .01; f.x += Math.sin(f.a) * .6;
          if (f.y > H + 5) { f.y = -5; f.x = Math.random() * W; }
          ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283); ctx.fill();
        });
        requestAnimationFrame(frame);
      })();
    }

    var popup = $('[data-popup]');
    if (popup && !popup._p) {
      popup._p = true;
      var key = 'wn_popup_seen';
      var seen = false; try { seen = sessionStorage.getItem(key); } catch (e) {}
      var open = function () { popup.classList.add('is-open'); try { sessionStorage.setItem(key, '1'); } catch (e) {} };
      var close = function () { popup.classList.remove('is-open'); };
      $$('[data-popup-close]', popup).forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      if (/customer_posted=true/.test(location.search)) open();
      else if (!seen) setTimeout(open, parseInt(popup.dataset.delay, 10) || 6000);
    }
  }

  var parallaxEls = [];
  function onScroll() {
    if (document.body.dataset.parallax !== 'true') return;
    parallaxEls.forEach(function (el) {
      var host = el.closest('.hero,.vbanner') || el.parentNode; var r = host.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      el.style.transform = 'translateY(' + (r.top * -0.12).toFixed(1) + 'px) scale(1.15)';
    });
  }
  function initParallax() {
    parallaxEls = $$('.hero__media img, .vbanner__media img, .vbanner__media video');
    parallaxEls.forEach(function (el) { el.setAttribute('data-parallax-img', ''); });
    onScroll();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function () { initEffects(); initParallax(); });
  document.addEventListener('shopify:section:select', function (e) { var a = e.target.querySelector('[data-anim]') || e.target; if (a.hasAttribute && a.hasAttribute('data-anim')) a.classList.add('is-visible'); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initEffects(); initParallax(); });
  else { initEffects(); initParallax(); }

  /* slider arrows + drag for data-variant="slider" */
  function initSliders() {
    $$('[data-variant="slider"]').forEach(function (sec) {
      if (sec._sl) return;
      var sc = $('.product-grid,.tile-grid,.review-grid,.social-grid,.gallery,.mcols', sec);
      if (!sc) return; sec._sl = true;
      var wrap = document.createElement('div'); wrap.className = 'sx-nav-wrap';
      sc.parentNode.insertBefore(wrap, sc); wrap.appendChild(sc);
      ['prev', 'next'].forEach(function (d) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'sx-nav sx-nav--' + d;
        b.setAttribute('aria-label', d); b.innerHTML = d === 'prev' ? '&#8249;' : '&#8250;';
        b.addEventListener('click', function () { sc.scrollBy({ left: (d === 'prev' ? -1 : 1) * sc.clientWidth * 0.8, behavior: 'smooth' }); });
        wrap.appendChild(b);
      });
    });
  }
  document.addEventListener('shopify:section:load', initSliders);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSliders); else initSliders();

  /* progress bar, back-to-top, header shadow */
  (function () {
    var bar, top, hd;
    function upd() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar = bar || $('[data-progress]'); top = top || $('[data-to-top]'); hd = hd || $('[data-header]');
      if (bar) bar.style.width = (h > 0 ? y / h * 100 : 0) + '%';
      if (top) top.classList.toggle('is-visible', y > 600);
      if (hd) hd.classList.toggle('is-scrolled', y > 10);
      if (hd && hd.hasAttribute('data-hide-scroll')) {
        var down = y > (upd.last || 0) && y > 160;
        var open = document.querySelector('.drawer[aria-hidden="false"],[data-search-bar]:not([hidden])');
        hd.classList.toggle('is-hidden', down && !open);
      }
      upd.last = y;
    }
    window.addEventListener('scroll', upd, { passive: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-to-top]')) window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    upd();
  })();

  /* count-up numbers */
  function initCounters() {
    var els = $$('[data-count-to]:not([data-counted])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-counted', '1');
      var raw = el.getAttribute('data-count-to'), end = parseFloat(String(raw).replace(',', '.')), dec = parseInt(el.getAttribute('data-count-dec'), 10) || 0;
      if (isNaN(end)) return;
      var t0 = null, dur = 1600;
      function step(ts) {
        if (!t0) t0 = ts; var p = Math.min((ts - t0) / dur, 1); var e = 1 - Math.pow(1 - p, 3);
        el.textContent = (end * e).toLocaleString('de-DE', { minimumFractionDigits: dec, maximumFractionDigits: dec });
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { run(x.target); io.unobserve(x.target); } }); }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('shopify:section:load', initCounters);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCounters); else initCounters();

  /* ===== Shop features: modals, quick view, search, wishlist, recent, upsell ===== */
  function openModal(m) { if (!m) return; m.setAttribute('aria-hidden', 'false'); root.classList.add('modal-open'); }
  function closeModals() { $$('.modal[aria-hidden="false"]').forEach(function (m) { m.setAttribute('aria-hidden', 'true'); }); root.classList.remove('modal-open'); }
  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if (!t.closest) return;
    if ((el = t.closest('[data-modal-open]'))) { openModal(document.getElementById(el.getAttribute('data-modal-open'))); return; }
    if (t.closest('[data-modal-close]')) { closeModals(); return; }
    if ((el = t.closest('[data-quick-view]'))) {
      e.preventDefault();
      var modal = document.getElementById('QuickViewModal'), box = $('[data-modal-content]', modal);
      box.innerHTML = '<div class="modal__loading"></div>'; openModal(modal);
      var u = el.getAttribute('data-url') + (el.getAttribute('data-url').indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view';
      fetch(u).then(function (r) { return r.text(); }).then(function (h) { var q = $('[data-qv]', parseHTML(h)); box.innerHTML = q ? q.outerHTML : ''; }).catch(function () { closeModals(); });
      return;
    }
    if ((el = t.closest('[data-wish]'))) { e.preventDefault(); toggleWish(el.getAttribute('data-handle')); return; }
    if ((el = t.closest('[data-hotspot]'))) {
      var h = el.parentNode, was = h.classList.contains('is-open');
      $$('.hotspot.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      if (!was) h.classList.add('is-open'); return;
    }
    if ((el = t.closest('[data-tab]'))) {
      var wrap = el.closest('[data-tabs]'), i = el.getAttribute('data-tab');
      $$('[data-tab]', wrap).forEach(function (b) { b.classList.toggle('is-active', b === el); });
      $$('[data-panel]', wrap).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === i); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModals(); });

  /* storage helpers */
  function store(key, val) { try { if (val === undefined) return JSON.parse(localStorage.getItem(key) || '[]'); localStorage.setItem(key, JSON.stringify(val)); } catch (e) { return []; } return val; }
  function toggleWish(handle) {
    var list = store('wn_wish'), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    store('wn_wish', list); syncWish();
    if (i === -1) toast('♥'); else { var g = $('[data-wishlist-grid]'); if (g) renderHandles(g, list, $('[data-wishlist-empty]')); }
  }
  function syncWish() {
    var list = store('wn_wish');
    $$('[data-wish]').forEach(function (b) { var on = list.indexOf(b.getAttribute('data-handle')) > -1; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });
  }
  function renderHandles(grid, handles, emptyEl) {
    grid.innerHTML = '';
    if (emptyEl) emptyEl.hidden = handles.length > 0;
    handles.forEach(function (h) {
      fetch('/products/' + encodeURIComponent(h) + '?section_id=wish-card').then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var card = $('[data-wish-card]', parseHTML(html));
        if (!card) return;
        var li = document.createElement('li'); li.innerHTML = card.innerHTML; grid.appendChild(li); syncWish();
      }).catch(function () {});
    });
  }
  function initWishlist() {
    syncWish();
    var g = $('[data-wishlist-grid]');
    if (g && !g._w) { g._w = true; renderHandles(g, store('wn_wish'), $('[data-wishlist-empty]')); }
  }
  function initRecent() {
    if (T.recent && T.product) { var l = store('wn_recent').filter(function (h) { return h !== T.product; }); l.unshift(T.product); store('wn_recent', l.slice(0, 14)); }
    $$('[data-recent]').forEach(function (g) {
      if (g._r) return; g._r = true;
      var ex = g.getAttribute('data-exclude'), lim = parseInt(g.getAttribute('data-limit'), 10) || 4;
      var l = store('wn_recent').filter(function (h) { return h !== ex; }).slice(0, lim);
      if (!l.length) { var s = g.closest('section'); if (s && !root.classList.contains('shopify-design-mode')) s.hidden = true; return; }
      renderHandles(g, l);
    });
  }

  /* predictive search */
  function initPredictive() {
    var input = $('[data-predictive]');
    if (!input || input._p || !T.predictive) return; input._p = true;
    var out = $('[data-predictive-results]'), timer, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctrl && ctrl.abort) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
        fetch(T.searchUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=5&section_id=predictive-search', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (h) { var p = $('.psearch', parseHTML(h)); out.innerHTML = p ? p.outerHTML : ''; })
          .catch(function () {});
      }, 220);
    });
  }

  /* cart upsell + complementary */
  function loadRecs(el, intent, limit, heading) {
    var pid = el.getAttribute('data-product-id');
    if (!pid) return;
    fetch('/recommendations/products?product_id=' + pid + '&limit=' + limit + '&intent=' + intent + '&section_id=recs-compact')
      .then(function (r) { return r.text(); })
      .then(function (h) {
        var list = $('.rc', parseHTML(h));
        el.innerHTML = list ? '<p class="rc__heading">' + heading + '</p>' + list.outerHTML : '';
      }).catch(function () {});
  }
  function initUpsell() {
    $$('[data-cart-upsell]').forEach(function (el) { loadRecs(el, 'related', 4, T.upsellHeading || ''); });
  }
  function initComplementary() {
    $$('[data-complementary]').forEach(function (el) { if (el._c) return; el._c = true; loadRecs(el, 'complementary', el.getAttribute('data-limit') || 3, el.getAttribute('data-heading') || ''); });
  }

  /* gift toggle, delivery estimate, before/after, localization */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-gift-toggle]')) {
      var m = t.closest('.giftopt').querySelector('[data-gift-message]');
      if (m) { m.hidden = !t.checked; var ta = m.querySelector('textarea'); if (ta) ta.disabled = !t.checked; }
    }
    if (t.matches && t.matches('[data-auto-submit]')) t.form.submit();
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-ba-range]')) e.target.closest('[data-ba]').style.setProperty('--pos', e.target.value + '%');
  });
  function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
  function initDelivery() {
    $$('[data-delivery-estimate]').forEach(function (el) {
      var cut = parseInt(el.dataset.cutoff, 10), lead = parseInt(el.dataset.lead, 10) || 0, mn = parseInt(el.dataset.min, 10), mx = parseInt(el.dataset.max, 10);
      var now = new Date(), biz = now.getDay() !== 0 && now.getDay() !== 6, before = biz && now.getHours() < cut;
      var base = lead + (before ? 0 : 1);
      var from = addBiz(now, base + mn), to = addBiz(now, base + mx);
      var f = function (d) { return d.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }); };
      var txt = '';
      if (before) {
        var left = new Date(now); left.setHours(cut, 0, 0, 0); var mins = Math.max(0, Math.round((left - now) / 60000));
        txt = '<strong>' + (el.dataset.before || '').replace('[time]', Math.floor(mins / 60) + ' Std ' + (mins % 60) + ' Min') + '</strong>';
      }
      txt += (el.dataset.between || '').replace('[from]', '<strong>' + f(from) + '</strong>').replace('[to]', '<strong>' + f(to) + '</strong>');
      $('[data-delivery-text]', el).innerHTML = txt;
    });
  }
  function initFeatures() { initWishlist(); initRecent(); initPredictive(); initUpsell(); initComplementary(); initDelivery(); }
  document.addEventListener('shopify:section:load', initFeatures);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFeatures); else initFeatures();
})();
/* v8.62 cookie preferences link */
document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('[data-cookie-prefs]');if(!a)return;e.preventDefault();try{var cp=window.Shopify&&window.Shopify.customerPrivacy;if(cp&&cp.showPreferences){cp.showPreferences();}else if(window.privacyBanner&&window.privacyBanner.showPreferences){window.privacyBanner.showPreferences();}}catch(x){}});
